// extracted by mini-css-extract-plugin
module.exports = {"container":"EditableLabel_container__2aC8l","name":"EditableLabel_name__23MId","button":"EditableLabel_button__1Q78p","icon":"EditableLabel_icon__1vgSO"};